module.exports = __webpack_public_path__ + "static/media/PolaoPlate.74ca62e1.png";